import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Card, CardBody} from 'reactstrap';
import withAuth from '../../../../components/Services/WithAuth';
import TableView from './TableView/index';
import { automatedOverriddingRiskFactorList } from './action';
class AutomatedOverridingRiskFactorList extends Component {
    constructor() {
        super();
        this.state = {
            overriddingRiskFactorData: []
        };
    }
    componentDidMount() {
        this.props.automatedOverriddingRiskFactorList();
    }
    componentDidUpdate(prevProps) {
        console.log("-------------")
        console.log(this.props.overRiddingRiskFactorListData)
        if (this.props.overRiddingRiskFactorListData !== prevProps.overRiddingRiskFactorListData) {
            this.setState({
                overriddingRiskFactorData: this.props.overRiddingRiskFactorListData.data
            })
        }
    }
    handleCancel = () => {
        this.props.history.push('../search')
    }
    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">List of Overridding Risk Factors</h4>
                </div>
                <Card>
                    <CardBody>
                        <TableView {...this.props} data={this.state.overriddingRiskFactorData} />
                    </CardBody>
                </Card>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    overRiddingRiskFactorListData: state.automatedOverriddingRiskFactor.automatedOverriddingRiskList
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    automatedOverriddingRiskFactorList: () => { dispatch(automatedOverriddingRiskFactorList()) }
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(AutomatedOverridingRiskFactorList));
